import { render, staticRenderFns } from "./BusinessReport.vue?vue&type=template&id=d3c7b0ac"
import script from "./BusinessReport.vue?vue&type=script&lang=js"
export * from "./BusinessReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports